import { __awaiter } from 'tslib';

const ENDPOINT = 'POSTpitchRequest';
function postPitchRequest(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.post(postPitchRequest.endpoint, params, params, customURL, customHeaders, null, isKoussa);
    });
}
postPitchRequest.endpoint = ENDPOINT;

export { postPitchRequest as default };
//# sourceMappingURL=postPitchRequest.js.map
